<div class="bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900 p-4">
  <div class="max-w-5xl mx-auto">
    <!-- Barre de progression -->
    <app-progress-bar
      [currentStep]="currentStep"
      [totalSteps]="totalSteps"
    ></app-progress-bar>

    <!-- Titre -->
    <h2 class="text-xl font-bold mb-1 mt-3">
      Contexte de votre point de vente
    </h2>
    <p class="text-gray-600 dark:text-gray-400 text-xs mb-4">
      Ces informations nous aident à personnaliser vos recommandations.
    </p>

    <!-- Formulaire -->
    <form [formGroup]="form" class="space-y-3 mb-4">
      <!-- Services & Périodicité - 2 colonnes -->
      <div class="grid md:grid-cols-2 gap-3">
        <!-- Services -->
        <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700">
          <h3 class="text-sm font-bold mb-2 text-gray-900 dark:text-white">
            🍽️ Services proposés
          </h3>
          <div class="space-y-1.5">
            @for (service of serviceOptions; track service) {
              <button
                type="button"
                (click)="toggleService($any(service.key))"
                class="w-full p-2 rounded-lg border text-xs font-medium transition-all text-left"
              [ngClass]="{
                'bg-blue-50 dark:bg-blue-900/20 border-blue-500 text-blue-900': isServiceSelected(
                  $any(service.key)
                ),
                'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-blue-300':
                  !isServiceSelected($any(service.key)),
              }"
                >
                {{ service.label }}
              </button>
            }
          </div>
        </div>

        <!-- Périodicité -->
        <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700">
          <h3 class="text-sm font-bold mb-2 text-gray-900 dark:text-white">📅 Fréquence</h3>
          <div class="space-y-1.5">
            @for (period of periodicityLabels | keyvalue; track period) {
              <button
                type="button"
                (click)="selectPeriodicity($any(period.key))"
                class="w-full p-2 rounded-lg border text-xs font-medium transition-all text-left"
              [ngClass]="{
                'bg-blue-50 dark:bg-blue-900/20 border-blue-500 text-blue-900':
                  form.value.periodicity === period.key,
                'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-blue-300':
                  form.value.periodicity !== period.key,
              }"
                >
                {{ period.value }}
              </button>
            }
          </div>
        </div>
      </div>

      <!-- Affluence -->
      <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700">
        <h3 class="text-sm font-bold mb-2 text-gray-900 dark:text-white">
          👥 Affluence habituelle
        </h3>
        <div class="grid grid-cols-3 gap-2">
          @for (option of affluenceOptions; track option) {
            <button
              type="button"
              (click)="selectAffluence($any(option.key))"
              class="p-2 rounded-lg border transition-all text-center"
            [ngClass]="{
              'bg-blue-50 dark:bg-blue-900/20 border-blue-500 text-blue-900': isFieldSelected(
                'affluence',
                option.key
              ),
              'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-blue-300':
                !isFieldSelected('affluence', option.key),
            }"
              >
              <div class="font-semibold text-xs">{{ option.label }}</div>
              <div class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                {{ option.description }}
              </div>
            </button>
          }
        </div>
      </div>

      <!-- Exposition météo & Équipe - 2 colonnes -->
      <div class="grid md:grid-cols-2 gap-3">
        <!-- Exposition météo -->
        <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700">
          <h3 class="text-sm font-bold mb-2 text-gray-900 dark:text-white">
            ☀️ Protection météo
          </h3>
          <div class="space-y-1.5">
            @for (option of coverageOptions; track option) {
              <button
                type="button"
                (click)="selectCoverage(option.id)"
                class="w-full p-2 rounded-lg border transition-all text-left"
              [ngClass]="{
                'bg-blue-50 dark:bg-blue-900/20 border-blue-500 text-blue-900': isCoverageSelected(
                  option.id
                ),
                'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-blue-300':
                  !isCoverageSelected(option.id),
              }"
                >
                <div class="font-semibold text-xs">{{ option.label }}</div>
                <div class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                  {{ option.description }}
                </div>
              </button>
            }
          </div>
        </div>

        <!-- Taille de l'équipe -->
        <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700">
          <h3 class="text-sm font-bold mb-2 text-gray-900 dark:text-white">👥 Taille équipe</h3>
          <div class="space-y-1.5">
            @for (option of teamSizeOptions; track option) {
              <button
                type="button"
                (click)="selectTeamSize($any(option.key))"
                class="w-full p-2 rounded-lg border transition-all text-left"
              [ngClass]="{
                'bg-blue-50 dark:bg-blue-900/20 border-blue-500 text-blue-900': isFieldSelected(
                  'teamSize',
                  $any(option.key)
                ),
                'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-blue-300':
                  !isFieldSelected('teamSize', $any(option.key)),
              }"
                >
                <div class="font-semibold text-xs">{{ option.label }}</div>
                <div class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                  {{ option.description }}
                </div>
              </button>
            }
          </div>
        </div>
      </div>
    </form>

    <!-- V1 — Positionnement tarifaire -->
    <app-positioning-selector
      [selectedPositioning]="selectedPositioning"
      (positioningChange)="selectedPositioning = $event"
    ></app-positioning-selector>

    <!-- Boutons de navigation -->
    <div class="flex justify-between mt-6">
      <!-- Bouton Retour -->
      <button
        (click)="goBack()"
        class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-colors bg-gray-200 dark:bg-slate-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-slate-600 hover:text-gray-900 dark:hover:text-white dark:text-white"
        >
        ← Précédent
      </button>

      <!-- Bouton Continuer -->
      <button
        (click)="continue()"
        class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-all"
        [ngClass]="{
          'bg-indigo-600 hover:bg-indigo-700 text-white shadow-md dark:shadow-slate-900/50 hover:shadow-lg dark:shadow-slate-900/50':
            form.valid,
          'bg-gray-300 text-gray-500 dark:text-gray-400 cursor-not-allowed': !form.valid,
        }"
        [disabled]="!form.valid"
        >
        Continuer →
      </button>
    </div>
  </div>
</div>
